// src/data/vocabulary/general/index.js

import house from './house.json';  
import fastfood from './fastfood.json';
import restaurants from './restaurants.json';
import clothes from './clothes.json';
import airportSurvival from './airport survival.json'; 
// ✅ Corregido: 'kitchenAndDrinks' en lugar de 'kitchen and drinks'
import kitchenAndDrinks from './kitchen and drinks.json';
// ✅ Corregido: 'marketDay' en lugar de 'market day'
import marketDay from './market day.json';
import Saludos from './Saludos.json';
import verbs1 from './verbs1.json';
import verbs2 from './verbs2.json';
import verbs3 from './verbs3.json';
import music from './music.json';
import outdoor from './outdoor.json';
import DIY from './DIY.json';
import wellness from './wellness.json';
import martialarts from './martialarts.json';
import collectiveanimal from './collectiveanimal.json';

export const VocabularyGeneral = [
    house,
    fastfood,
    restaurants,
    clothes,
    airportSurvival,
    kitchenAndDrinks,
    marketDay,
    Saludos,
    verbs1,
    verbs2,
    verbs3,
    music,
    outdoor,
    DIY,
    wellness,
    martialarts,
    collectiveanimal
];